import {loadAndShowModal} from "./modal";

document.addEventListener('DOMContentLoaded', function () {
    const facebookReviews = document.getElementsByClassName('js-reviewOnFacebook');

    for (let i = 0; i < facebookReviews.length; i++) {
        const facebookReview = facebookReviews[i];
        if (facebookReview) {
            facebookReview.addEventListener('click', async function () {
                await loadAndShowModal('give_us_a_review', {
                    size: 'modal-lg',
                });
            });
        }
    }
});
